import { TriggerPoint } from "pages/survey/surveyService";

export type ExitSurveyBorrowerType = "primary" | "spouse" | "nscb" | "unknown";

export type ExitIntentFsTrigger = "BrowserBack" | "NavigateAway";

const PRIMARY_FULL_PATH_BLOCKED_C_STEPS = new Set(["C1", "C2", "C3", "C37", "C41"]);
const SPOUSE_FULL_PATH_BLOCKED_STEPS = new Set(["C10", "C11", "C12", "C39", "C43"]);
const NSCB_FULL_PATH_BLOCKED_STEPS = new Set(["C16", "C17", "C18", "C19", "C38", "C42"]);

const isFullPath = (path: string | undefined) => (path ?? "").toLowerCase() === "fullpath";

export function isExitSurveyEligibleStep(
  borrowerType: ExitSurveyBorrowerType,
  path: string | undefined,
  stepCode: string
): boolean {
  const code = stepCode?.toUpperCase() ?? "";
  if (!code) return false;

  switch (borrowerType) {
    case "primary":
      if (code.startsWith("B")) return false;
      if (isFullPath(path)) return !PRIMARY_FULL_PATH_BLOCKED_C_STEPS.has(code);
      return true;
    case "spouse":
      if (isFullPath(path)) return !SPOUSE_FULL_PATH_BLOCKED_STEPS.has(code);
      return true;
    case "nscb":
      if (code === "C16") return false;
      if (isFullPath(path)) return !NSCB_FULL_PATH_BLOCKED_STEPS.has(code);
      return true;
    default:
      return false;
  }
}

export function getExitIntentFsTrigger(triggerPoint: TriggerPoint | null): ExitIntentFsTrigger | null {
  if (triggerPoint === TriggerPoint.BrowserBack) return "BrowserBack";
  if (triggerPoint === TriggerPoint.NavigateAway) return "NavigateAway";
  return null;
}
